
import { UserInfo } from '@/types/user-info';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { State } from 'vuex-class';

export interface QuickOption {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handler: (...args: any[]) => any;
    key: string;
    title: string;
}

@Component({
    components: {},
})
export default class QuickActions extends Vue {
    @Prop({
        required: false,
        default() {
            return '';
        },
    })
    className!: string;

    @Prop({ required: true })
    availableActions!: QuickOption[];

    @Prop({ required: false })
    visibleActions!: string[];

    @State('user')
    user!: UserInfo;

    get visible() {
        return this.availableActions.filter((action) => this.visibleActions.includes(action.key)).filter(action =>
            !(this.user.roles.includes('sharedUser') && action.key === 'remove')
        );
    }
}
